/* PetitGarage · interacciones del tema (sin librerías) */
(function () {
  'use strict';
  var CLAVE = 'pg-favoritos';

  function leerFavs() {
    try { return JSON.parse(localStorage.getItem(CLAVE) || '[]') || []; } catch (e) { return []; }
  }
  function guardarFavs(l) {
    try { localStorage.setItem(CLAVE, JSON.stringify(l)); } catch (e) {}
  }
  function pintarFavs() {
    var favs = leerFavs();
    document.querySelectorAll('[data-fav-count]').forEach(function (el) {
      el.textContent = favs.length ? String(favs.length) : '';
      el.classList.toggle('is-on', favs.length > 0);
    });
    document.querySelectorAll('[data-fav]').forEach(function (b) {
      var on = favs.indexOf(b.getAttribute('data-fav')) >= 0;
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (b.hasAttribute('data-fav-texto')) b.textContent = on ? 'Guardado en favoritos ✓' : 'Guardar en favoritos';
    });
  }

  document.addEventListener('click', function (ev) {
    var b = ev.target.closest('[data-fav]');
    if (b) {
      ev.preventDefault();
      var h = b.getAttribute('data-fav');
      var favs = leerFavs();
      var i = favs.indexOf(h);
      if (i >= 0) favs.splice(i, 1); else favs.unshift(h);
      guardarFavs(favs);
      b.classList.remove('is-late'); void b.offsetWidth; b.classList.add('is-late');
      pintarFavs();
      return;
    }
    if (ev.target.closest('[data-pg-cookies]')) {
      ev.preventDefault();
      try {
        if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') { window.privacyBanner.showPreferences(); return; }
      } catch (e) {}
      window.location.href = '/policies/privacy-policy';
      return;
    }
    var t = ev.target.closest('[data-pg-tabs] [role="tab"]');
    if (t) {
      var cont = t.closest('[data-pg-tabs]');
      cont.querySelectorAll('[role="tab"]').forEach(function (x) {
        var sel = x === t;
        x.setAttribute('aria-selected', sel ? 'true' : 'false');
        var p = document.getElementById(x.getAttribute('aria-controls'));
        if (p) p.hidden = !sel;
      });
      return;
    }
    var f = ev.target.closest('[data-ir-foto]');
    if (f) {
      var gal = f.closest('[data-pg-galeria]');
      var n = f.getAttribute('data-ir-foto');
      var foto = gal.querySelector('[data-foto="' + n + '"]');
      var pista = gal.querySelector('.pg-galeria__pista');
      if (foto && pista) pista.scrollTo({ left: foto.offsetLeft - pista.offsetLeft, behavior: 'smooth' });
      gal.querySelectorAll('[data-ir-foto]').forEach(function (x) { x.setAttribute('aria-current', x === f ? 'true' : 'false'); });
    }
  });

  // Teclado en las pestañas de «Cómo funciona»
  document.addEventListener('keydown', function (ev) {
    var t = ev.target.closest && ev.target.closest('[data-pg-tabs] [role="tab"]');
    if (!t || (ev.key !== 'ArrowRight' && ev.key !== 'ArrowLeft')) return;
    var tabs = Array.prototype.slice.call(t.parentNode.querySelectorAll('[role="tab"]'));
    var i = tabs.indexOf(t) + (ev.key === 'ArrowRight' ? 1 : -1);
    var sig = tabs[(i + tabs.length) % tabs.length];
    sig.focus(); sig.click();
  });

  // Ordenar colección
  document.querySelectorAll('[data-pg-orden]').forEach(function (s) {
    s.addEventListener('change', function () {
      var u = new URL(window.location.href);
      u.searchParams.set('sort_by', s.value);
      u.searchParams.delete('page');
      window.location.href = u.toString();
    });
  });

  // Galería: al deslizar, marca la miniatura
  document.querySelectorAll('[data-pg-galeria]').forEach(function (gal) {
    var pista = gal.querySelector('.pg-galeria__pista');
    if (!pista) return;
    pista.addEventListener('scroll', function () {
      var i = Math.round(pista.scrollLeft / pista.clientWidth) + 1;
      gal.querySelectorAll('[data-ir-foto]').forEach(function (x) { x.setAttribute('aria-current', x.getAttribute('data-ir-foto') === String(i) ? 'true' : 'false'); });
    }, { passive: true });
  });

  // Página de favoritos: trae cada tarjeta desde /products/<handle>?view=card
  var lista = document.querySelector('[data-pg-favoritos]');
  if (lista) {
    var favs = leerFavs();
    var vacio = document.querySelector('[data-pg-favoritos-vacio]');
    if (!favs.length) { if (vacio) vacio.hidden = false; }
    else {
      Promise.all(favs.map(function (h) {
        return fetch('/products/' + encodeURIComponent(h) + '?view=card', { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; });
      })).then(function (htmls) {
        var vivos = [];
        htmls.forEach(function (html, i) { if (html.indexOf('pg-card') >= 0) { lista.insertAdjacentHTML('beforeend', html); vivos.push(favs[i]); } });
        if (vivos.length !== favs.length) guardarFavs(vivos);
        if (!vivos.length && vacio) vacio.hidden = false;
        pintarFavs();
        // Botón para preguntar por todos los favoritos disponibles por WhatsApp
        var cajaWa = document.querySelector('[data-pg-fav-wa]'), linkWa = document.querySelector('[data-pg-fav-wa-link]');
        var cods = [].slice.call(lista.querySelectorAll('.pg-card')).filter(function (c) {
          return c.getAttribute('data-codigo') && !c.querySelector('.pg-vendido-banda');
        }).map(function (c) { return '#' + c.getAttribute('data-codigo').replace(/^#/, ''); });
        if (cajaWa && linkWa && cods.length) {
          var txt = cods.length === 1 ? 'Hola, me interesa el ' + cods[0] : 'Hola, me interesan estos productos: ' + cods.join(', ');
          linkWa.href = 'https://wa.me/' + ((window.PG && window.PG.whatsapp) || '56958172135') + '?text=' + encodeURIComponent(txt);
          if (cods.length === 1) linkWa.textContent = 'Preguntar por este producto por WhatsApp';
          cajaWa.hidden = false;
          cajaWa.style.display = 'flex';
        }
      });
    }
  }

  pintarFavs();
})();
